/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { db_DropdownChildhoodSchoolType } from '../models/db_DropdownChildhoodSchoolType';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class ChildhoodSchoolTypes {
    /**
     * Get a list of childhood school types
     * @returns db_DropdownChildhoodSchoolType OK
     * @throws ApiError
     */
    public static listChildhoodSchoolTypes(): CancelablePromise<Array<db_DropdownChildhoodSchoolType>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/childhood-school-types',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
